import type markCleaningsAsPaid from '../../../../hosting-server/src/core/functions/markCleaningsAsPaid';
import { createServerHook } from '../../core/hooks/serverHooksCreators';

const useMarkCleaningsAsPaid = createServerHook<typeof markCleaningsAsPaid>(
    'markCleaningsAsPaid'
);

export default useMarkCleaningsAsPaid;
